package com.wintermar.inspection.feature.domain.usecase.auth

import com.wintermar.inspection.core.data.AppSetting
import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.feature.domain.model.auth.LoginModel
import com.wintermar.inspection.feature.domain.repository.AuthRepository
import com.wintermar.inspection.util.Constant
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.onEach

/**
 * KMP Compatibility: As you discovered, Kotlin Multiplatform (Native/iOS) has strict rules about final classes.
 * Interfaces are the most "stable" way to handle mocks across all platforms (Android, iOS, Desktop) in 2025.
 */
interface LoginUseCase {
    operator fun invoke(email: String, password: String): Flow<FlowResult<LoginModel>>
}

class LoginUseCaseImpl(
    private val authRepository: AuthRepository,
    private val appSetting: AppSetting
) : LoginUseCase {
    override operator fun invoke(email: String, password: String): Flow<FlowResult<LoginModel>> {
        return authRepository.login(email, password).onEach { result ->
            if (result is FlowResult.Success) {
                // Save token here so it's centralized
                result.data?.let {
                    appSetting.apply {
                        setToken(
                            authToken = it.token,
                            refreshToken = it.refreshToken,
                            userId = it.user.userId,
                            userFullName = it.user.fullName
                        )

                        setAccess(
                            inspectionAccess = it.user.listAccess.contains(Constant.INSPECTION_ACCESS),
                            templateAccess = it.user.listAccess.contains(Constant.TEMPLATE_ACCESS)
                        )
                    }
                }
            }
        }
    }
}
